export default __webpack_public_path__ + "static/media/64.b97c6c2c.png";